import type { HTMLComponent } from "@commercekit/react";
import type { PopularProductsSliceBlogContentPage } from "prismicio-types";
import WvProductItem from "~/components/molecules/WvProductItem";
import type { WovarCustomer, WovarProduct } from "@commercekit/api";
import { asText } from "@prismicio/helpers";

const WvPopularProductsBlogContentPage: HTMLComponent<{
  products: WovarProduct[];
  slice: PopularProductsSliceBlogContentPage;
  customer?: WovarCustomer;
}> = ({ products, slice, customer }) => {
  return (
    <section className="col-12">
      <h2 className="heading lg mb-5"> {asText(slice?.primary?.title)}</h2>
      <div className="row">
        {products?.length
          ? products?.map((product) => (
              <WvProductItem
                className="col-12 col-sm-6 col-xxl-4 mb-3 mb-sm-4"
                key={product.sku}
                product={product}
                itemListId="blog_popular_product"
                itemListName="Blog Popular Product"
                customer={customer}
                showOnlyPriceExclVat={slice?.primary?.show_only_price_excl_vat}
              />
            ))
          : null}
      </div>
    </section>
  );
};

export default WvPopularProductsBlogContentPage;
